/**
  Author - Brijesh Pandey
  Git - https://bitbucket.org/__brijesh/
**/

const suitcaseIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-suitcase.png";
const bankIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-bank.png";
const umbrellaIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-insurance.png";
const buildingIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-nonfinance.svg";
const thumbsUpIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-other.svg";
const coinIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-sales.png";
const priceBagIcon = "https://i.wlycdn.com/wealth-managers/agent-onboarding-occupation-finance.png";


const reasonToJoin = {
  question: "How can Wealthy help you?",
  description: "This will help us know you better as a wealth partner",
  answerKey: "reason_to_join",
  options: [
    {
      // icon: coinIcon,
      title: "Earn second income",
      subtitle: "",
      next: null,
      value: "second income source"
    },
    {
      // icon: priceBagIcon,
      title: "Sell a wider range of financial products",
      subtitle: "",
      next: null,
      value: "get more products"
    },
    {
      // icon: priceBagIcon,
      title: "Start own wealth management business",
      subtitle: "",
      next: null,
      value: "start own finance business"
    },
    {
      // icon: priceBagIcon,
      title: "Not sure, Just exploring",
      subtitle: "",
      next: null,
      value: "exploring"
    }
  ]
};

const currentRole = {
  question: "Select all the products you have sold",
  description: "You can choose more than one answer",
  answerKey: "product_experience",
  isCheckbox: true,
  options: [
    {
      title: "Mutual Funds",
      subtitle: "",
      value: "mutual funds",
      next: reasonToJoin
    },
    {
      title: "Stocks",
      subtitle: "",
      value: "stocks",
      next: reasonToJoin
    },
    {
      title: "Life Insurance",
      subtitle: "",
      value: "life insurance",
      next: reasonToJoin
    },
    {
      title: "Health Insurance",
      subtitle: "",
      value: "health insurance",
      next: reasonToJoin
    },
    {
      title: "PMS / AIF",
      subtitle: "",
      value: "pms or aif",
      next: reasonToJoin
    },
    {
      title: "Bonds / Debentures",
      subtitle: "",
      value: "bonds or debentures",
      next: reasonToJoin
    },
    {
      title: "None",
      subtitle: "",
      value: "none",
      next: reasonToJoin
    }
  ]
};



const onboardingQuestions = {
  question: "Select your profession",
  description: "This will help us know you better as a wealth partner",
  answerKey: "current_occupation",

  options: [
    {
      // icon: suitcaseIcon,
      title: "Insurance Agent",
      // subtitle: "i am currently employed with a company",
      value: "IA",
      next: currentRole
    },
    {
      // icon: suitcaseIcon,
      title: "Bank Employee",
      value: "BE",
      next: currentRole
    },
    {
      // icon: suitcaseIcon,
      title: "Mutual Fund Distributor",
      value: "MFD",
      next: currentRole
    },
    {
      // icon: suitcaseIcon,
      title: "Chartered Accountant",
      value: "CA",
      next: currentRole
    },
    {
      // icon: suitcaseIcon,
      title: "Stock Broker",
      value: "SB",
      next: currentRole
    },
    {
      // icon: suitcaseIcon,
      title: "Others",
      value: "OT",
      next: currentRole
    }
  ]
};

export default onboardingQuestions;
